import React from 'react';
import { Plus, Trash2, AlertTriangle } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

// Free units in a cámara, ignoring what this sample already had saved there
const freeFor = (cam, sampleId) => {
  const own = cam.muestras.filter((m) => m.id === sampleId && m.activa).reduce((a, m) => a + m.cantidad, 0);
  return cam.libre + own;
};

const CamarasAsignacionSection = ({ entries, onChange, ocupacion, sampleId }) => {
  const update = (idx, patch) => onChange(entries.map((e, i) => (i === idx ? { ...e, ...patch } : e)));
  const totalIn = (camId) => entries.filter((e) => e.camara_id === camId).reduce((a, e) => a + (parseInt(e.cantidad, 10) || 0), 0);

  return (
    <div className="space-y-3 p-4 border rounded-lg bg-gray-50" data-testid="camaras-asignacion-section">
      <div className="flex items-center justify-between">
        <h4 className="font-semibold text-gray-700">Cámaras</h4>
        <Button type="button" size="sm" variant="outline" onClick={() => onChange([...entries, { camara_id: '', cantidad: 1 }])} data-testid="add-camara-asignacion-btn">
          <Plus size={14} className="mr-1" /> Añadir cámara
        </Button>
      </div>
      {entries.length === 0 && <p className="text-sm text-gray-500">Sin cámara asignada.</p>}
      {entries.map((entry, idx) => {
        const cam = ocupacion.find((c) => c.id === entry.camara_id);
        const libre = cam ? freeFor(cam, sampleId) : null;
        const exceso = cam && totalIn(cam.id) > libre;
        return (
          <div key={idx} className="space-y-1">
            <div className="flex flex-col md:flex-row gap-2 md:items-end">
              <div className="flex-1 space-y-1">
                <Label className="text-xs">Cámara</Label>
                <Select value={entry.camara_id} onValueChange={(v) => update(idx, { camara_id: v })}>
                  <SelectTrigger data-testid={`camara-select-${idx}`}><SelectValue placeholder="Selecciona una cámara" /></SelectTrigger>
                  <SelectContent>
                    {ocupacion.map((c) => (
                      <SelectItem key={c.id} value={c.id}>
                        {c.name} — {freeFor(c, sampleId)} libres de {c.capacidad}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              <div className="md:w-40 space-y-1">
                <Label className="text-xs">Unidades</Label>
                <Input type="number" min="1" value={entry.cantidad} onChange={(e) => update(idx, { cantidad: e.target.value })} data-testid={`camara-cantidad-${idx}`} />
              </div>
              <Button type="button" variant="outline" size="sm" onClick={() => onChange(entries.filter((_, i) => i !== idx))} data-testid={`remove-camara-asignacion-${idx}`}>
                <Trash2 size={14} />
              </Button>
            </div>
            {exceso && (
              <p className="text-xs text-amber-700 flex items-center gap-1" data-testid={`camara-aviso-${idx}`}>
                <AlertTriangle size={12} /> La cámara {cam.name} superará su capacidad ({libre} libres). Puedes guardar igualmente.
              </p>
            )}
          </div>
        );
      })}
      {entries.length > 0 && (
        <p className="text-xs text-gray-600" data-testid="camaras-total-unidades">
          Total unidades en cámaras: {entries.reduce((a, e) => a + (parseInt(e.cantidad, 10) || 0), 0)}
        </p>
      )}
    </div>
  );
};

export default CamarasAsignacionSection;
